'use strict';

import template from '../templates/PasswordRuleTable.ejs';

module.exports = Backbone.View.extend({
    tagName:   'div',
    className: 'password-rule-table',

    initialize: function() {

        this.render();
        return this;
    },

    render: function() {
        this.$el.html(template());

        return this;
    },

    toggleRuleDisplay: function(evt) {
        const password = evt.target.value;

        this.$('#rule-8-chars').toggleClass(
            'rule-match',
            password.length >= 8
        );
        this.$('#rule-1-num').toggleClass(
            'rule-match',
            /[0-9]+/.test(password)
        );
        this.$('#rule-1-alphabet').toggleClass(
            'rule-match',
            /[a-zA-Z]+/.test(password)
        );
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/PasswordRuleTable.js